<template>
    <AdaptersDialog
        :header="title"
        :listener-id="getListenerId"
        :callback-on-hide="onClose"
    >
        <template #content>
            <div class="modal-body" v-if="chartData">
                <AdaptersChart :chart-data="getChartData" />
            </div>
        </template>
    </AdaptersDialog>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import AdaptersDialog from "../../../component/adapters/Dialog.vue";
import AdaptersChart from "../../../component/adapters/Chart.vue";
import {ArrayHelper} from "../../../helpers/ArrayHelper";
import { Interaction } from 'chart.js';
import { getRelativePosition } from 'chart.js/helpers';

export default {
    name: "WordstatPopupWsGraph",
    data() {
        return {
            title: null,
            chartData: null,
        }
    },
    mounted() {
        this.$emitter.on(Listeners.KS_TABLE_POPUP_ONLINE_PARSER_WS, responseData => {
            this.title = this.$t('lang.wordstat.report.graph_title', [responseData.word]);
            this.$emitter.emit(Listeners.KS_TABLE_POPUP_ONLINE_PARSER_WS_OPEN);
            this.setChartData(responseData.chartData);
        });
    },
    computed: {
        getListenerId() {
            return Listeners.KS_TABLE_POPUP_ONLINE_PARSER_WS_OPEN;
        },
        getChartData() {
            return this.chartData;
        },
    },
    methods: {
        onClose() {
            this.chartData = null;
        },
        setChartData(chartData) {
            const labels = ArrayHelper.getAttrValuesOfObjectsByName(chartData, 'date');
            const data = ArrayHelper.getAttrValuesOfObjectsByName(chartData, 'count');

            this.chartData = {
                labels: labels,
                datasets: [{
                    label: this.$t('lang.wordstat.report.ws_graph_main'),
                    data,
                    fill: false,
                    borderColor: "rgb(54, 162, 235)",
                    borderWidth: 1,
                }],
            };
        },
    },
    components: {
        AdaptersChart,
        AdaptersDialog
    },
}
</script>
